import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as GoIcons from "react-icons/go";
import { VscDashboard } from "react-icons/vsc";
import { Link, useLocation } from "react-router-dom";
import "./NavbarStyles.css";
import { IconContext } from "react-icons";
import { useDispatch, useSelector } from "react-redux";
import { NavbarBrand, Nav, NavDropdown } from "react-bootstrap";
import { logout } from "../actions/userActions";
import Product from "./Product";
import "../App.css";
import Swal from "sweetalert2";

const URL = process.env.NODE_ENV === "production" ? '' : "http://localhost:3001";
function Navbar({ match }) {
  const [showAlert, setShowAlert] = useState(false);
  const [messageString, setMessageString] = useState("");
  const [warningSet, setWarningSet] = useState([]);
  const [enableWarning, setEnableWarning] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [products, setProducts] = useState([]);
  const [popCount, setPopProduct] = useState(0);
  const [usersMenuOpen, setUsersMenuOpen] = useState(false);
  const [dashboardMenuOpen, setDashboardMenuOpen] = useState(false);
  const [createdByMeUsers, setCreatedByMeUsers] = useState([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const dashboardTo = location.pathname === "/dashboard" ? `/dashboard${location.search}` : "/dashboard";
  const Alert =
    useMemo(() => showAlert &&
    Swal.fire({
      title: "Alert",
      text: messageString,
      icon: "warning",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Okay",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        if (!warningSet.includes(messageString)) warningSet.push(messageString);
        setEnableWarning(false)
      }
    }), [showAlert, messageString]);

  const logoutHandler = () => {
    dispatch(logout());
  };

  useEffect(() => {
    if (
      !userInfo ||
      !userInfo.token ||
      (userInfo.role !== "MAIN_ADMIN" && userInfo.role !== "LOCAL_ADMIN")
    ) {
      setCreatedByMeUsers([]);
      return;
    }
    const config = { headers: { Authorization: `Bearer ${userInfo.token}` } };
    axios
      .get(URL + "/api/users/created-by-me", config)
      .then(({ data }) => setCreatedByMeUsers(Array.isArray(data) ? data : []))
      .catch(() => setCreatedByMeUsers([]));
  }, [userInfo]);

  useEffect(() => {
    const fetchgenSetData = async () => {
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
  
      const { data } = await axios.get(URL +`/api/products`, config);
      const filter = (productFromApi) => {
        const errorMessages = []
        const {
          batteryVoltage,
          fuelLevel,
          batteryVoltageOffset,
          engineCoolantTemp,
          engineCoolantTempOffset,
          frequency,
          frequencyOffset,
          fuelLevelOffset,
          powerFactor,
          powerFactorOffset,
          powerKW,
          powerKWOffset,
          gensetNumber,
          getsetStatus,
          voltage,
          current,
          voltageOffset,
          currentOffset,
          lastUpdated,
          isConnected, 
          remainingHours
        } = productFromApi;
        const lastupdatedTime = new Date(lastUpdated[lastUpdated.length - 1])
        lastupdatedTime.setHours(0,0,0,0)
        const nowTime = new Date()
        nowTime.setHours(0,0,0,0)
        const { vY, vR, vB } = voltage[voltage.length - 1];
        const { iY, iR, iB } = current[current.length - 1];
        if (getsetStatus === "ON" && !isConnected) {
          return [];
        }
        if (getsetStatus === "OFF" && lastupdatedTime.getTime() !== nowTime.getTime()) {
          return [];
        }
        if ((vY < voltageOffset.min || vR < voltageOffset.min || vB < voltageOffset.min) && isConnected) {
          errorMessages.push(`AC Voltage at Genset No: ${gensetNumber} is Low`)
        } 
        if (batteryVoltage[batteryVoltage.length - 1] < batteryVoltageOffset.min) {
          errorMessages.push(`Battery Voltage at Genset No: ${gensetNumber} is Low`)
        }
        if (fuelLevel[fuelLevel.length - 1] < fuelLevelOffset.min) {
          errorMessages.push(`Fuel Level at Genset No: ${gensetNumber} is Low`)
        }
        if (remainingHours < 0) {
          errorMessages.push(`Service is due for : ${gensetNumber}`)
        }
        if (frequency[frequency.length - 1] < frequencyOffset.min && isConnected) {
          errorMessages.push(`Frequency at Genset No: ${gensetNumber} is Low`)
        }
        if (frequency[frequency.length - 1] > frequencyOffset.max && isConnected) {
          errorMessages.push(`Frequency at Genset No: ${gensetNumber} is High`)
        }
        if (powerFactor[powerFactor.length - 1] < powerFactorOffset.min && isConnected) {
          errorMessages.push(`Power Factor at Genset No: ${gensetNumber} is Low`)
        } 
        if (powerKW[powerKW.length - 1] > powerKWOffset.max && isConnected) {
          errorMessages.push(`Active Power at Genset No: ${gensetNumber} is High`)
        } 
        if (engineCoolantTemp[engineCoolantTemp.length - 1] > engineCoolantTempOffset.max) {
          errorMessages.push(`Engine Coolant Temprature at Genset No: ${gensetNumber} is High`)
        } 
        if ((vY > voltageOffset.max || vR > voltageOffset.max || vB > voltageOffset.max) && isConnected){
          errorMessages.push(`AC Voltage at Genset No: ${gensetNumber} is High`)
        } 
        if ((iY > currentOffset.max || iR > currentOffset.max || iB > currentOffset.max) && isConnected){
          errorMessages.push(`Current at Genset No: ${gensetNumber} is High`)
        }
        return errorMessages
      }
      if (userInfo.role === "USER") {
        const productWarnings = data.map(e => filter(e))
        const warnings = productWarnings.flat().filter(e => !warningSet.includes(e) && e.length !== 0)

        if (!enableWarning && warnings.length) {
          setMessageString(warnings[0])
          setShowAlert(true)
          setEnableWarning(true)
        }
        setProducts(data);
      }
      
    };
    const timer = setTimeout(() => {
      if (popCount < 10) {
        setPopProduct(popCount + 1);
        console.log(popCount);
      } else {
        setPopProduct(0);
        console.log(popCount);
      }
      fetchgenSetData();
    }, 10000);
  }, [match, popCount]);

  useEffect(() => {
    const fetchallgenSetData = async () => {
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
  
      const { data } = await axios.get(URL + `/api/products`, config);
      setProducts(data);
    };
    fetchallgenSetData();
  }, [match]);
  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      <IconContext.Provider
        value={{ color: "#fff" }}
        className="tw-absolute tw-z-50"
      >
        <div className="navbarHome navbar-top tw-font-nunito">
          <img
            src={"/indianarmy.jpg"}
            alt="Indian Army"
            width={100}
            height={100}
          />
          <Link to="/" className="tw-ml-4 tw-no-underline ">
            <NavbarBrand
              className="tw-font-bold md:tw-text-4xl tw-text-base tw-text-md tw-tracking-widest"
              style={{ color: "#b7c0a5" }}
            >
              VIDYUT RAKSHAK<sup style={{
                    fontSize: "8px",
                    backgroundColor: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    top: "-30px",
                    fontWeight: "bold"
              }}>{userInfo?.username} ({userInfo?.role})</sup>
            </NavbarBrand>
          </Link>
          <div className="tw-flex tw-w-screen tw-justify-end tw-items-center tw-mr-4 tw-font-nunito">
            <img
              src={"/makeinindia.jpg"}
              alt="Make in India"
              width={100}
              height={100}
              className="sm:tw-w-24 tw-w-16"
            />
            <button
              type="button"
              className="menu-bars tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0"
              onClick={showSidebar}
              aria-label="Toggle menu"
            >
              <FaIcons.FaBars style={{ color: "#93a178" }} />
            </button>
          </div>
        </div>
        <nav
          className={
            sidebar
              ? "nav-menu navbar-top active tw-font-nunito"
              : "nav-menu navbar-top tw-font-nunito"
          }
        >
          <ul className="nav-menu-items" onClick={showSidebar}>
            <li className="navbar-toggle-bar">
              <button
                type="button"
                className="menu-bars tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0 tw-text-inherit"
                onClick={showSidebar}
                aria-label="Close menu"
              >
                <IoIcons.IoMdClose />
              </button>
            </li>
            {userInfo ? (
              <div>
                <li className="nav-text tw-text-white">
                  Welcome &nbsp; <strong>{userInfo.username}!</strong>
                </li>
              </div>
            ) : (
              ""
            )}
            {(userInfo && (userInfo.role === "MAIN_ADMIN" || userInfo.role === "LOCAL_ADMIN")) ? (
              <li className="nav-users-menu">
                <div
                  className="nav-users-toggle"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDashboardMenuOpen((o) => !o);
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.stopPropagation();
                      setDashboardMenuOpen((o) => !o);
                    }
                  }}
                >
                  <VscDashboard />
                  <span className="nav-users-toggle-label">Dashboard</span>
                  <FaIcons.FaChevronDown
                    className="nav-users-chevron"
                    style={{
                      transform: dashboardMenuOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </div>
                {dashboardMenuOpen && (
                  <ul className="nav-users-sublist">
                    <li>
                      <Link to="/admin/userlist">All users</Link>
                    </li>
                    {createdByMeUsers.map((u) => (
                      <li key={u._id}>
                        <Link to={`/dashboard?userId=${u._id}`}>
                          • {u.username}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ) : (
              <li className="nav-text">
                <Link to={dashboardTo}>
                  <VscDashboard />
                  <span>Dashboard</span>
                </Link>
              </li>
            )}

            {userInfo && (
              <li className="nav-text tw-text-white tw-text-lg tw-font-semibold">
                Admin Dashboard
              </li>
            )}
            {userInfo && (
              <>
                {(userInfo.role === "MAIN_ADMIN" || userInfo.role === "LOCAL_ADMIN") && (
                  <li className="nav-text">
                    <Link to="/admin/userlist">
                      <FaIcons.FaUsers />
                      <span>Users</span>
                    </Link>
                  </li>
                )}
                {(userInfo.role === "MAIN_ADMIN" || userInfo.role === "LOCAL_ADMIN") && <li className="nav-text">
                  <Link to="/register">
                    <FaIcons.FaUser />
                    <span>Add Users</span>
                  </Link>
                </li>}
              </>
            )}

            {userInfo ? (
              <li className="nav-text">
                <Link to="/profile">
                  <IoIcons.IoMdPeople />
                  <span>My Profile</span>
                </Link>
              </li>
            ) : (
              <li className="nav-text">
                <Link to="/login">
                  <i className="fas fa-user"></i> <span>Sign In</span>
                </Link>
              </li>
            )}

            {userInfo && (
              <>
                <li className="nav-text">
                  <Link to="/admin/productlist">
                    <AiIcons.AiOutlineDashboard />
                    <span>Generators List</span>
                  </Link>
                </li>
                {(userInfo.role === "MAIN_ADMIN") && <li className="nav-text">
                  <Link to="/admin/product/create">
                    <AiIcons.AiOutlineAppstoreAdd />
                    <span>Add Generator</span>
                  </Link>
                </li>}
                <li className="nav-text">
                  <Link to="/admin/product/reports">
                    <AiIcons.AiOutlineAppstoreAdd />
                    <span>Reports</span>
                  </Link>
                </li>
              </>
            )}
            {userInfo ? (
              <div>
                <li className="nav-text">
                  <Link onClick={logoutHandler} to="/">
                    <AiIcons.AiOutlineLogout /> <span>Logout</span>
                  </Link>
                </li>
              </div>
            ) : (
              ""
            )}
          </ul>
        </nav>
      </IconContext.Provider>
      
    </>
  );
}

export default Navbar;
